<script setup>
import { useNotificationPermission } from "@/composables/permissions/notification";
import BellIcon from "@/components/Icons/Bell.vue";
import { usePwaInstall } from "@/plugins/pwa-install";
import { computed } from "vue";

const notification = useNotificationPermission();
const pwa = usePwaInstall();

const helpText = computed(() => {
    if (!pwa.isUnderStandaloneMode) {
        return "Please enable it from your browser permission settings.";
    }

    return "Please enable it from your device's app settings then close corperland app and re-open it.";
});
</script>

<template>
    <div
        v-if="notification.permission === 'denied'"
        class="bg-danger/10 text-danger border border-danger p-3 rounded-md mb-3"
    >
        <div
            class="flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-x-4"
        >
            <div class="flex items-center gap-x-4">
                <BellIcon class="size-8" />
                <div>
                    <p class="font-medium leading-tight">
                        Notifications have been disabled on this device
                    </p>
                    <p class="text-sm">
                        {{ helpText }}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div
        v-else-if="notification.permission === 'default'"
        class="bg-warning/10 text-warning border border-warning p-3 rounded-md mb-3"
    >
        <div
            class="flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-x-4"
        >
            <div class="flex items-center gap-x-4">
                <BellIcon class="size-8" />
                <div>
                    <p class="font-medium leading-tight">
                        Enable notifications to stay connected
                    </p>
                    <p class="text-sm">
                        Get notified about new messages and updates from your
                        friends and channels
                    </p>
                </div>
            </div>
            <app-button
                v-if="notification.permission == 'default'"
                capitalize
                compact
                color="warning-border"
                class="self-end md:self-auto capitalize"
                @click="notification.enable()"
            >
                Enable
            </app-button>
        </div>
    </div>
</template>
